const IMAGE_EXTS = ["jpg", "jpeg", "png", "gif", "webp", "bmp", "svg", "heic"];
const SCAN_EXTS = ["stl", "ply", "obj"];

export function fileExt(fileName) {
    if (!fileName || fileName.indexOf(".") === -1) return "";
    return fileName.split(".").pop().toLowerCase();
}

export function isImage(fileName) {
    return IMAGE_EXTS.includes(fileExt(fileName));
}

export function isScan(fileName) {
    return SCAN_EXTS.includes(fileExt(fileName));
}

export function fileCategory(fileName) {
    if (isImage(fileName)) return "images";
    if (isScan(fileName)) return "scans";
    return "other";
}

export function fileIcon(fileName) {
    if (isScan(fileName)) return "bi-box";
    return "bi-file-earmark";
}

export function fileTypeLabel(fileName) {
    if (isImage(fileName)) return "Image";
    if (isScan(fileName)) return "Digital scan";
    const ext = fileExt(fileName);
    return ext ? ext.toUpperCase() + " file" : "File";
}

export function formatSize(bytes) {
    if (bytes === null || bytes === undefined || isNaN(bytes)) return "";
    if (bytes < 1024) return `${bytes} B`;
    const units = ["KB", "MB", "GB", "TB"];
    let value = bytes / 1024;
    let i = 0;
    while (value >= 1024 && i < units.length - 1) {
        value /= 1024;
        i++;
    }
    return `${value >= 100 ? Math.round(value) : value.toFixed(1)} ${units[i]}`;
}

export default { fileExt, isImage, isScan, fileCategory, fileIcon, fileTypeLabel, formatSize };
